app.controller('outboundViewCtrl', function ($rootScope, $scope,_API_URL, $state, $window, shareData,modalFactory,modalService, $filter, urlServices, _VAR_GLOBAL,toaster,$location) {
    function getOutboundListAwb(row) {
        return row ? (row.AWB || row.NoBukti || '') : '';
    }

    function chooseDeleteReason(title, awb, callback) {
        modalFactory.open('md', 'modal.delete-awb-reason.html', 'modalDeleteAwbReasonCtrl', {
            title: title,
            entryLabel: 'Outbound',
            awb: awb
        }).result.then(function (payload) {
            return callback(null, payload && payload.reason ? payload.reason : '');
        }, function () {
            return callback(null, null);
        });
    }

    function buildOutboundPrintUrl(awb, mode) {
        var printUrl = '/outbound-print?awb=' + encodeURIComponent(awb);

        if (mode === 'hardcopy') {
            printUrl += '&mode=hardcopy';
        }
        return printUrl;
    }

    $scope.deleteAuthorized = false;
        $scope.filter = '';
        $scope.dataList = {
            totalItems: 0,
            summary:{},
            data: []
        };
        $scope.paginationOptions = {
            pageNumber: 1,
            pageSize: _VAR_GLOBAL.limit,
            sort: null
        };
        $scope.perTglP = {
            startDate: moment().subtract(7, 'days'),
            endDate: moment()
        };
        $scope.edit=function(dt){
            var awb = getOutboundListAwb(dt);

            if (!awb) {
                return toaster.pop('warning', 'Outbound', 'No AWB tidak boleh kosong');
            }
            return window.location = '/outbound-entry?awb=' + encodeURIComponent(awb) + '&isedit=true';
        };
        $scope.refreshData=function(){
            return $scope.viewData(1,{is_approve:0});
        };
        $scope.viewData = function (pg,qry) {
            console.log($scope.filter);
            $scope.paginationOptions.pageNumber = pg;
            $scope.getData($scope.paginationOptions.pageSize, $scope.paginationOptions.pageNumber, $scope.filter,qry);
        };
        $scope.detail=function(n){
            return $scope.edit(n);
        };
        $scope.print = function (row) {
            var awb = getOutboundListAwb(row);

            if (!awb) {
                return toaster.pop('warning', 'Outbound', 'No AWB tidak boleh kosong');
            }

            modalFactory.open('sm', 'modal.outbound-print-option.html', 'modalOutboundPrintOptionCtrl', {
                awb: awb,
                entryLabel: 'Outbound'
            }).result.then(function (selection) {
                window.open(buildOutboundPrintUrl(awb, selection && selection.mode), '_blank');
            }, function () {});
        };
        $scope.hapus = function (row) {
            var awb = getOutboundListAwb(row);

            if (!awb) {
                return toaster.pop('warning', 'Outbound', 'No AWB tidak boleh kosong');
            }
            if (!$scope.deleteAuthorized) {
                return toaster.pop('warning', 'Outbound', 'Anda tidak memiliki otoritas hapus outbound');
            }

            chooseDeleteReason('Alasan Hapus Outbound', awb, function (reasonErr, reasonText) {
                if (reasonErr) {
                    return toaster.pop('error', 'Outbound', reasonErr);
                }
                if (!reasonText) {
                    return;
                }

                urlServices.hapusData('api/outbound/' + encodeURIComponent(awb) + '?deleteReason=' + encodeURIComponent(reasonText), {
                    reason: reasonText
                }, function (err) {
                    if (err) {
                        return toaster.pop('error', 'Outbound', err.err || err || 'Data outbound gagal dihapus');
                    }

                    toaster.pop('success', 'Outbound', awb + ' berhasil dihapus');
                    $scope.viewData($scope.paginationOptions.pageNumber || 1);
                });
            });
        };
        $scope.getData = function (pageSize, page, searchText, qry) {
            var qry = qry||{};
            setTimeout(function () {
                var data;
                if (searchText) {
                    var ft = encodeURIComponent(String(searchText || '').trim());
                    data = 'term=' + ft + '&limit=' + pageSize + '&pg=' + page + '&start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd");
                } else {
                    data = 'limit=' + pageSize + '&pg=' + page +   '&start_date=' + $filter('date')($scope.perTglP.startDate._d, "yyyy-MM-dd") + '&end_date=' + $filter('date')($scope.perTglP.endDate._d, "yyyy-MM-dd");
                }
                console.log('---->',data);
                urlServices.ambilData('api/outbound/filter?' + data, {}, function (err, sukses) {
                    console.log(sukses);
                    if (err) {
                        toaster.pop('error', 'Error', err.err || err);
                        $scope.dataList.totalItems = 0;
                        $scope.dataList.data = []
                    } else {
                        //console.log(sukses);
                        $scope.dataList.totalItems = sukses.records;
                        $scope.dataList.data = sukses.data;
                        console.log($scope.dataList);
                    }
                })
            }, 100);
        };
        $scope.$watch('perTglP', function (newDate) {
            //console.log('New date set: ', newDate);
            $scope.viewData(1);
        }, false);

        urlServices.ambilData('api/outbound/defaultdata', {}, function (err, result) {
            if (!err && result) {
                $scope.deleteAuthorized = !!result.canDeleteOutbound;
            }
        });
    })
